import { render, staticRenderFns } from "./batchDelivery.vue?vue&type=template&id=022cf644"
import script from "./batchDelivery.vue?vue&type=script&lang=js"
export * from "./batchDelivery.vue?vue&type=script&lang=js"
import style0 from "./batchDelivery.vue?vue&type=style&index=0&id=022cf644&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports